<template>
  <div class="btn-box">
    <a href="#" v-if="action === 'stream'" @click.prevent="clickPlayerFn()" class="player-button">{{buttonName}}</a>
    <div v-else class="player-notice-apollo">
      <span>구매가 필요한 콘텐츠입니다.</span>
      <span>구매는 Wavve 앱 또는 PC사이트에서 가능합니다.</span>
    </div>
  </div>
</template>
<script>
import { get, indexOf } from 'lodash'
import { UserService } from '@/common/api/api.service'
export default {
  name: 'ApolloPlayerActionButton',
  props: {
    clickPlayerFn: {
      type: Function
    },
    contentInfo: {
      type: Object
    },
    section: {
      type: String
    }
  },
  data () {
    return {
      action: '',
      buttonName: ''
    }
  },
  methods: {
    moveToLogin () {
      this.$router.replace(`/member/login?referer=${this.$route.fullPath}`)
    },
    moveToVoucher () {
      const contentId = get(this.contentInfo, 'contentid', '')
      const movieId = get(this.contentInfo, 'movieid', '')
      const programId = get(this.contentInfo, 'programid', '')
      const channelId = get(this.contentInfo, 'channelid', '')
      const type = this.section === 'movie' ? 'movie' : 'voucher'
      const cpId = get(this.contentInfo, 'cpid', '')
      const playy = indexOf(get(this.contentInfo, 'moviemarks', []), 'playy') > -1 ? 'y' : 'n'
      const query = { type: type, contenttype: this.section, channelid: channelId, contentid: contentId, programid: programId, cpid: cpId }
      const movieQuery = {
        type: type,
        contenttype: this.section,
        channelid: channelId,
        contentid: movieId || contentId,
        programid: movieId || contentId,
        cpid: cpId,
        playy: playy
      }
      this.$router.push({
        name: 'voucher_popup_new_for_app',
        query: this.section === 'movie' ? movieQuery : query
      })
    },
    init () {
      let path = 'movieid'
      if (this.section === 'vod') {
        path = 'contentid'
        this.section = get(this.contentInfo, 'type', '') === 'general' ? 'vod' : 'qvod'
      } else if (this.section === 'live') {
        path = 'channelid'
      }
      const contentId = get(this.contentInfo, path, '')
      UserService.getPermissionForContent({ contentId, contentType: this.section }).then(({ data }) => {
        this.action = get(data, 'action', '')
        this.buttonName = get(data, 'display', '')
      })
    }
  },
  created () {
    this.init()
  }
}
</script>
